var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagicWandOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.37375 8.39667C5.19974 8.48865 5.01149 8.30039 5.10347 8.12639L6.09531 6.25002L5.10347 4.37365C5.01149 4.19964 5.19974 4.01139 5.37375 4.10337L7.25012 5.09521L9.12649 4.10336C9.3005 4.01139 9.48875 4.19964 9.39677 4.37365L8.40493 6.25002L9.39677 8.12639C9.48875 8.30039 9.3005 8.48865 9.12649 8.39667L7.25012 7.40483L5.37375 8.39667Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2501 6.90483L15.3738 7.89667C15.1997 7.98865 15.0115 7.80039 15.1035 7.62639L16.0953 5.75002L15.1035 3.87365C15.0115 3.69964 15.1997 3.51139 15.3738 3.60336L17.2501 4.59521L19.1265 3.60337C19.3005 3.51139 19.4888 3.69964 19.3968 3.87365L18.4049 5.75002L19.3968 7.62639C19.4888 7.80039 19.3005 7.98865 19.1265 7.89667L17.2501 6.90483Z",
    fill: "#023F80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3738 17.3967C15.1997 17.4887 15.0115 17.3004 15.1035 17.1264L16.0953 15.25L15.1035 13.3736C15.0115 13.1996 15.1997 13.0114 15.3738 13.1034L17.2501 14.0952L19.1265 13.1034C19.3005 13.0114 19.4888 13.1996 19.3968 13.3736L18.4049 15.25L19.3968 17.1264C19.4888 17.3004 19.3005 17.4887 19.1265 17.3967L17.2501 16.4048L15.3738 17.3967Z",
    fill: "#023F80"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1365 10.3636C13.488 10.7151 13.488 11.2849 13.1365 11.6364L3.63649 21.1364C3.28502 21.4879 2.71517 21.4879 2.3637 21.1364C2.01223 20.785 2.01223 20.2151 2.3637 19.8636L11.8637 10.3636C12.2152 10.0122 12.785 10.0122 13.1365 10.3636Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicWandOutline);
export default __webpack_public_path__ + "static/media/magic_wand_outline.c746ea782c995e3f67e88f8cb16cce73.svg";
export { ForwardRef as ReactComponent };